<template>
  <div class="custom-container"><slot></slot></div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CustomContainer extends Vue {}
</script>

<style lang="scss" scoped></style>
